export default __webpack_public_path__ + "static/media/woman.3f889d0a.png";